{
    "NAME": "Linguaggio di gestione delle licenze",
    "LicenseManagement_Action_Refresh": "Aggiorna lo stato della licenza",
    "LicenseManagement_Action_Reload": "Licenze di ricarica",
    "LicenseManagement_Reload_Confirm": "Ricaricare i dati della licenza?",
    "LicenseManagement_Reload_Success": "Dati di licenza ricaricati.",
    "LicenseManagement_Status_Title": "Stato attuale della licenza",
    "LicenseManagement_Status_Empty": "Non sono disponibili informazioni sullo stato della licenza.",
    "LicenseManagement_Status_LimitedAccess": "Per l'ambito corrente è disponibile solo lo stato complessivo della licenza.",
    "LicenseManagement_Status_Entry": "Iscrizione",
    "LicenseManagement_Status_Value": "Valore",
    "LicenseManagement_Status_Usage": "Utilizzo",
    "LicenseManagement_Status_Status": "Stato",
    "LicenseManagement_Profiles_Title": "Profili del server di telefonia",
    "LicenseManagement_Profiles_Empty": "Non sono disponibili profili server di telefonia.",
    "LicenseManagement_Billing_Title": "Rapporti di fatturazione",
    "LicenseManagement_Billing_Filters": "Filtri",
    "LicenseManagement_Billing_Advanced": "Opzioni avanzate",
    "LicenseManagement_Billing_Actions": "Azioni",
    "LicenseManagement_Billing_OnlyBillable": "Configurazione a pagamento soltanto",
    "LicenseManagement_Billing_SystemWideUsers": "Includi gli utenti a livello di sistema",
    "LicenseManagement_Billing_BillingExcluded": "Includi configurazioni escluse dalla fatturazione",
    "LicenseManagement_Billing_Simulation": "Includi sistemi telefonici di simulazione",
    "LicenseManagement_Billing_Summary": "Riepilogo della fatturazione",
    "LicenseManagement_Billing_Cdr": "CDR di fatturazione",
    "LicenseManagement_Billing_SummaryConfirm": "Generare il report di riepilogo della fatturazione?",
    "LicenseManagement_Billing_CdrConfirm": "Generare il report CDR di fatturazione?",
    "LicenseManagement_Diagnostic": "Referto diagnostico",
    "LicenseManagement_Diagnostic_Confirm": "Generare il report di licenza diagnostica?",
    "LicenseManagement_Filter_Cme": "Formazione continua in medicina (CME)",
    "LicenseManagement_Filter_TelSys": "Server di telefonia",
    "LicenseManagement_Filter_Partition": "Partizione"
}